import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["employerId", "employerName", "employerExternalId"];

  connect() {
    this.employerIdTarget.addEventListener("change", this.onChange.bind(this));
  }

  onChange() {
    if (this.employerIdTarget.value === "NEW") {
      this.employerNameTarget.value = "";
      this.employerExternalIdTarget.value = "";
      this.employerNameTarget.parentElement.classList.remove("hidden");
      this.employerExternalIdTarget.parentElement.classList.remove("hidden");
    } else {
      this.employerNameTarget.parentElement.classList.add("hidden");
      this.employerExternalIdTarget.parentElement.classList.add("hidden");
      var selectedOption = this.employerIdTarget.options[this.employerIdTarget.selectedIndex];
      this.employerNameTarget.value = selectedOption.getAttribute("data-name");
      this.employerExternalIdTarget.value = selectedOption.getAttribute("data-external-id");
    }

    // Dispatch change events for the name and external ID fields so that they can be validated.
    this.employerNameTarget.dispatchEvent(new Event("change"));
    this.employerExternalIdTarget.dispatchEvent(new Event("change"));
  }

}